import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Footer = () => {
  return (
    <footer className="bg-stone-900 text-stone-400 py-24">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-16 mb-24">
          
          <div className="md:col-span-4">
            <a href="#" className="font-serif text-3xl tracking-tighter text-white block mb-8">
              GlowDock<span className="text-stone-500">.</span>
            </a>
            <p className="text-sm font-light leading-relaxed mb-8 max-w-xs">
              Exceptional skincare for the intentional individual. Formulated in Stockholm, inspired by botanical essentialism.
            </p>
            <div className="flex gap-6">
              <a href="#" className="text-white hover:text-stone-400 transition-colors"><SafeIcon icon={FiIcons.FiInstagram} className="w-5 h-5" /></a>
              <a href="#" className="text-white hover:text-stone-400 transition-colors"><SafeIcon icon={FiIcons.FiYoutube} className="w-5 h-5" /></a>
              <a href="#" className="text-white hover:text-stone-400 transition-colors"><SafeIcon icon={FiIcons.FiLinkedin} className="w-5 h-5" /></a>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-white text-[11px] font-bold uppercase tracking-[0.2em] mb-8">Explore</h4>
            <ul className="space-y-4 text-xs tracking-widest font-medium uppercase">
              <li><a href="#" className="hover:text-white transition-colors">Shop All</a></li>
              <li><a href="#" className="hover:text-white transition-colors">The Rituals</a></li>
              <li><a href="#" className="hover:text-white transition-colors">About Us</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Journal</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-white text-[11px] font-bold uppercase tracking-[0.2em] mb-8">Concierge</h4>
            <ul className="space-y-4 text-xs tracking-widest font-medium uppercase">
              <li><a href="#" className="hover:text-white transition-colors">Contact</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Shipping</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Returns</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Stockists</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-white text-[11px] font-bold uppercase tracking-[0.2em] mb-8">Newsletter</h4>
            <p className="text-sm font-light mb-8">Join our community for exclusive access to new launches and mindful living guides.</p>
            <form className="flex group border-b border-stone-700 focus-within:border-white transition-colors pb-2">
              <input 
                type="email" 
                placeholder="EMAIL ADDRESS" 
                className="bg-transparent border-none outline-none flex-grow text-[10px] font-bold tracking-widest text-white placeholder-stone-600"
              />
              <button type="submit" className="text-[10px] font-bold uppercase tracking-widest text-white hover:text-stone-400 transition-colors">
                Join
              </button>
            </form>
          </div>

        </div>

        <div className="pt-12 border-t border-stone-800 flex flex-col md:flex-row justify-between items-center gap-6 text-[10px] font-bold tracking-[0.2em] uppercase">
          <p className="text-stone-600">&copy; {new Date().getFullYear()} GlowDock Studio Stockholm AB.</p>
          <div className="flex gap-10">
            <a href="#" className="hover:text-white transition-colors">Privacy</a>
            <a href="#" className="hover:text-white transition-colors">Terms</a>
            <a href="#" className="hover:text-white transition-colors">Accessibility</a>
          </div>
        </div>
      </div>
            <p className="text-center" style={{ textTransform: 'none' }}><span>Made by </span><a href="https://diglab.ai/" target="_blank" rel="noopener noreferrer" style={{ textTransform: 'none' }}>DigLab.ai</a><span> and </span><a href="https://linglinkai.cn/" target="_blank" rel="noopener noreferrer" style={{ textTransform: 'none' }}>LingLinkAI.cn</a></p>
      </footer>
  );
};

export default Footer;